import { exportOptionsFromRouteInfo } from 'teacher-ui-client/utils/routing'
import RouteTemplate from 'ember-route-template'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingUiScopeSelect } from 'teacher-ui-client/components/reporting/ui-scope-select'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingExportSelect } from 'teacher-ui-client/components/reporting/export-select'
import { StudentSearchComponent } from 'teacher-ui-client/components/student-search'
import Component from '@glimmer/component'
import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'
import type ReReportingSkillsMasteredCohortRoute from 'teacher-ui-client/reporting/ui-scope/re/skills-mastered/cohort/route'
import { t } from 'ember-intl'

interface Signature {
  Args: {
    model: ModelFor<ReReportingSkillsMasteredCohortRoute>
  }
}
export class ReReportingSkillsMasteredCohortPage extends Component<Signature> {
  @service router!: RouterService

  get exportOptions() {
    return exportOptionsFromRouteInfo(this.router.currentRoute)
  }

  <template>
    <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.skillsMastered"}} />

    <ReportingControls>
      <ReportingUiScopeSelect class="shrink basis-80" />
      <ReportingControlsGap />
      <ReportingPeriodSelect />
      <ReportingExportSelect @exportOptions={{this.exportOptions}} />
      <ReportingControlsGap />
      <StudentSearchComponent
        @studentRouteName="reporting.ui-scope.re.student-summary.table"
        @students={{@model.scopedStudents}}
        @includeSelectAll={{false}}
      />
    </ReportingControls>

    {{outlet}}
  </template>
}

export default RouteTemplate(ReReportingSkillsMasteredCohortPage)
